export class CreateClientUserReqData {
    username: string;
    password: string;
    profileName: string;
    language: string;
    dateFormat: string;
    timeFormat: string;
    email: string;
}
